let clearTime = {};
export default {
	regs:{
		empty: /\S/,
		name:/^.{2,60}$/,
		content:/^.{5,500}$/,
		// eslint-disable-next-line no-useless-escape
		email:/^[a-zA-Z0-9.+=\/_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
		telReplace:/[^0-9_+-\s]/,
		phone:/^.{8,20}$/,
		password: /^.*(?=.{6,16})(?=.*[a-zA-Z0-9]).*$/
	},
	quoteServes:{
		smt:"assembly",
		pcb:"pcb",
		smd:"stencil",
		fpc:"pcb",
		rfpc:"pcb",
		bom:"bom",
		pcb_high: 'pcb'
	},
	getUrlParams(variable){
		//通用获取url参数方法
		var query = window.location.search.substring(1);
		var vars = query.split("&");
		for (var i=0;i<vars.length;i++) {
			var pair = vars[i].split("=");
			if(pair[0] == variable){return pair[1];}
		}
		return false;
	},
	debounce(fn,key,times){
		let wait = times || 800;
		if(typeof key === "number"){
			wait = key;
			key = "debounce";
		}
		return function(){
			if(clearTime[key]){
				clearTimeout(clearTime[key])
			}
			clearTime[key] = setTimeout(fn,wait);
		}
	},
	keepDecimal(nums,decimal,must) {
		// 不是数字，直接返回
		if(typeof nums !=='number' || isNaN(Number(nums))){
			return nums
		}
		//must 是否强制保留
		let num = nums.toString();
		if(num === ""){
			return num;
		}
		
		if(must){
			return parseFloat(num).toFixed(decimal);
		}else{
			let index = num.indexOf('.');
			if (index !== -1) {
				num = num.substring(0, decimal + index + 1)
			} else {
				num = num.substring(0)
			}
			return Number(num);
		}
	},
	inArray(value,arr,key,act){
		//判斷值是否存在于數組中
		if(!(arr instanceof Array)){
			return;
		}
		let len = arr.length;
		for(let i=0; i<len ;i++){
			if(key){
				if(value === arr[i][key]){
					if(act === "del") arr.splice(i,1);
					if(typeof act === "function") act(arr[i],i,arr);
					if(act === "index") return i;
					return true;
				}
			}else{
				if(value === arr[i]){
					if(act === "del") arr.splice(i,1);
					if(typeof act === "function") act(arr[i],i,arr);
					if(act === "index") return i;
					return true;
				}
			}
		}
		if(act === "index") return -1;
		return false;
	},
	assign(){
		let tmp = {};
		//對象合并到新對象
		let argLen = arguments.length;
		for(let i = 0; i< argLen;i++){
			if(arguments[i] instanceof Object){
				for (let k in arguments[i]){
					tmp[k] = arguments[i][k];
				}
			}
		}
		return tmp;
	},
	deepCopy(o,e){
		var c = e || (o instanceof Array?[]:{});
		if(o === null) return null;
		for(var i in o){
			if(o[i] && typeof o[i] === 'object'){
				if(o[i].constructor === Array){
					c[i] =[]
				}else{
					c[i] = {}
				}
				this.deepCopy(o[i],c[i]);
			}else{
				c[i] = o[i]
			}
		}
		return c
	},
	//sessionstorage
	setSlocal(key,value){
		try{
			sessionStorage.setItem(key,JSON.stringify(value));
		}catch(e){
			console.log(e)
		}
	},
	getSlocal(key){
		let rst = sessionStorage.getItem(key);
		try{
			return JSON.parse(rst);
		}catch(e){
			return rst;
		}
	},
	delSlocal(key){
		sessionStorage.removeItem(key);
	},
	setCookie(name, value, timesHour) {
		var str = name + "=" + escape(value); //编码
		if (timesHour > 0) {
			//为0时不设定过期时间，浏览器关闭时cookie自动消失
			var date = new Date();
			var ms = timesHour * 3600 * 1000;
			date.setTime(date.getTime() + ms);
			str += "; expires=" + date.toGMTString();
		}
		document.cookie = str;
	},
	getCookie(name){
		var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
			arr = document.cookie.match(reg);
		if(arr) {
			return unescape(arr[2]);
		} else {
			return null;
		}
	},
	//dom
	getElementByattr(tag,attr,reg){
		let aes = document.getElementsByTagName(tag);
		let items = [];
		for(let i = 0;i<aes.length;i++){
			let item = aes[i].getAttribute(attr);
			if(reg.test(item)){
				items.push(aes[i]);
			}
		}
		return items;
	},
	// 获取元素距离浏览器窗口左边和顶部的距离
	getOffset: function(element){
		var top = 0,left = 0;
		var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
		var scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft
		top = element.getBoundingClientRect().top + scrollTop;
		left= element.getBoundingClientRect().left + scrollLeft;
		// 该方法元素自身为fixed时，此时没有定位父级，offsetParent的结果为null
		// function getElementOffsetTop(element){
		// 	top += element.offsetTop;
		// 	left += element.offsetLeft;
		// 	if(element.offsetParent){
		// 		return getElementOffsetTop(element.offsetParent);
		// 	}
		// 	return element.offsetParent;
		// }
		// //模擬jQuery獲取元素到body頂部的距離
		// getElementOffsetTop(element);
		return {top:top,left:left};
	},
	setLanguageWords(list,LANG,vm){
		if(list instanceof Array){
			setWords(list)
		}else{
			for(let k in list){
				if(!list[k]) continue;
				setWords(list[k]);
			}
		}
		function setWords(items){
			let len = items.length;
			if(len){
				for(let i = 0;i<len;i++){
					let keys = items[i].keys;
					if(keys && LANG[keys]){
						vm.$set(items[i],"word",LANG[keys]);
					}
					//找出其他項
					let text_keys = items[i].text_keys;
					if(text_keys && LANG[text_keys]){
						vm.$set(items[i],"text",LANG[text_keys]);
					}
				}
			}
		}
	},
	//解析语言包变量
	resoleLANG(str,values){
		return Object.keys(values).reduce((acc, key) => {
			const regExp = new RegExp(`\\$\\<%${key}\\%>`, 'g');
			if(acc)	return acc.replace(regExp, values[key]);
		}, str);
	},
	createHash(len,type){
		if(!len) len = 8;
		len = Number(len);
		if(isNaN(len)) return;
		let hashs = {
			'0-9':['0','1', '2', '3', '4', '5', '6', '7', '8', '9'],
			'a-z':['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
			'A_Z':['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
			'special':['_','$','*']
		}
		let hashArr = [];
		if(!type){
			for(let k in hashs){
				hashArr = hashArr.concat(hashs[k]);
			}
		}
		let rstArr = [];		
		for (var i = 0; i < len; i ++) {
			rstArr.push(hashArr[Math.floor(Math.random()*(hashArr.length -1 ))]);
		}
		return rstArr.join('');
	},
	//设置计价返回
	setValuationData(arg){
		let o = this.deepCopy(arg);
		if(o && o.list && o.list.pcb){
			// //有优惠 1，pcb优惠
			// 	if(o.discount && o.discount.pcb){
			// 		key = o.discount.pcb.key;
			// 	}
			let deltimes = o.list.pcb.suggest.deltime;
			// 	if(deltimes[0] && deltimes[0].key){
			// 		key = deltimes[0].key;
			// 	}
			// 	if(key){
			// 		//特价
			// 		if(key === "pcb_order_special_events"){
			// 			//不展示
			// 			if(o.discount && o.discount.pcb){
			// 				o.discount.pcb.discount_amount= 0;
			// 			}
			// 			for(let i = 0;i<deltimes.length;i++){
			// 				deltimes[i].sale = o.discount.pcb.pcb_total;
			// 				deltimes[i].active = "special";
			// 				deltimes[i].activity_code = key;
			// 				deltimes[i].pcb_total_original = o.discount.pcb.pcb_total_original;
			// 			}
			// 		}else if(key === "new_customer_first_free"){
			// 			//新人首单免费
			// 			let saleObj;
			// 			if(o.discount && o.discount.pcb){
			// 				//不展示
			// 				o.discount.pcb.discount_amount= 0;
			// 				if(o.discount.pcb.special_price && (o.discount.pcb.check_special || o.discount.pcb.check_special === undefined)){
			// 					sale = o.discount.pcb.special_price;
			// 					saleObj = {
			// 						total: o.discount.pcb.pcb_total,
			// 						sale,
			// 						active:"special",
			// 						activity_code:"pcb_order_special_events",
			// 						name:deltimes[0].name,
			// 						pcb_total_original: o.discount.pcb.pcb_total_original
			// 					}
			// 				}
			// 			}
			// 			for(let i = 0;i<deltimes.length;i++){
			// 				if(deltimes[i].total == 0 || deltimes[i].total === undefined){
			// 					deltimes[i].sale = 0;
			// 					deltimes[i].active = "first";
			// 					deltimes[i].activity_code = key;
			// 					deltimes[i].pcb_total_original = o.discount.pcb.pcb_total_original;
			// 				}
			// 			}
			// 			if(saleObj)	deltimes.push(saleObj);
			// 		}else{
			// 			//默認添加到第一條
			// 			deltimes[0].activity_code = key;
			// 		}
			// 	}
			//设置唯一key
			for(let i = 0;i<deltimes.length;i++){
				deltimes[i].name = deltimes[i].name + "_" + i;
				deltimes[i].activity_code = deltimes[i].key
			}
			o.list.pcb.suggest.deltime = deltimes;
		}
		return o;
	},
	// 页面内元素滚动动画（参数1：dom元素，参数2：滚动到哪个高度）
	scrollAnmiate(htmlDom, targetHeight) {
		var nowScroll = htmlDom.scrollTop;
		var intervalTimer = setInterval(() => {
			if(htmlDom.scrollTop > targetHeight) {
				htmlDom.scrollTo(0,htmlDom.scrollTop-nowScroll/100)
			} else {
				clearInterval(intervalTimer)
			}
		},10)
	},
	// 不可承接参数弹窗提示
	showNoAcceptModal(typeValueObj, fieldsNameObj, _this) {
		let tipStr = ''
		for(let typeKey in typeValueObj) {
			if(typeKey === 'area') {
				tipStr += _this.LANG[fieldsNameObj[typeKey]]+ '<br/><br/>'
			} else if(typeKey === 'blayer'){
				tipStr += _this.LANG[fieldsNameObj[typeKey]] + '：' + typeValueObj[typeKey].join('-') + _this.LANG.layers + '<br/>'
			} else {
				tipStr += _this.LANG[fieldsNameObj[typeKey]] + '：' + typeValueObj[typeKey].join('/') + '<br/>'
			}
		}
		_this.$alert.confirm({
			title:_this.LANG.tips,
			skin:"quote-size-conver_alert",
			shadeClose: true,
			area:["400px","260px"],					
			content: tipStr,
			btns:[]
		})
	},
	// setssoLogin(list,token,redirect,$http){
	// 	for(let x = 0; x<list.length ;x++){
	// 		if(token) {
	// 			list[x].token = token;			
	// 			localStorage.setItem("token",token);	
	// 		}	
	// 		//alert(list[x])		
	// 		if(list[x].url.indexOf(document.domain)>=0){
	// 			$http.get(list[x].url,{params:{content:list[x].content}}).then((res)=>{
	// 				if((res && res.retCode == 200) || (res && res.status == 200)){
	// 					if(redirect) window.location.href = redirect;
	// 				}
	// 			});
	// 		}else{
	// 			var domain = list[x].url.split("/")[0]+"//"+list[x].url.split("/")[2];				
	// 			document.getElementById("hqiframe0").contentWindow.postMessage(list[x],domain);	
	// 		}			
	// 	}
	// },
	// 打开Hqonline官网
	goOpenHqonline() {
		const hostName = window.location.hostname
		if(hostName === 'www.nextpcb.com') {
			window.open('https://www.hqonline.com/')
		} else if(hostName === 'uat-www.nextpcb.com') {
			window.open('https://uat-www.hqonline.com/')
		} else {
			window.open('https://fat-www.hqonline.com/')
		}
	},
	// 获取hqonline官网链接
	getHqonlineUrl() {
		const hostName = window.location.hostname
		let hqonlineHref = ''
		if(hostName === 'www.nextpcb.com' || hostName === 'jp.nextpcb.com') {
			hqonlineHref = 'https://www.hqonline.com/'
		} else if(hostName === 'uat-www.nextpcb.com' || hostName === 'uat-jp.nextpcb.com') {
			hqonlineHref = 'https://uat-www.hqonline.com/'
		} else {
			hqonlineHref = 'https://fat-www.hqonline.com/'
		}
		return hqonlineHref
	},
	// 区分环境，获取passport域名
	getPassportHost() {
		const hostName = window.location.hostname
		let passportHost = ''
		if(hostName === 'www.nextpcb.com' || hostName === 'jp.nextpcb.com') {
			passportHost = 'https://passport.nextpcb.com'
		} else if(hostName === 'uat-www.nextpcb.com' || hostName === 'uat-jp.nextpcb.com') {
			passportHost = 'https://uat-passport.nextpcb.com'
		} else {
			passportHost = 'https://fat-passport.nextpcb.com'
		}
		return passportHost
	},
	// 指定元素滚动到页面中间
	domScrollToViewById(elId){
		if(!elId){
			return
		}
		const el = document.getElementById(elId)
		if (el) {
			el.scrollIntoView({ behavior: 'smooth', block: 'center' })
		}
	},
	getAllUrlParameters(url) {
		const queryString = url.split('?')[1] || ''
		if(queryString == '') {
			return null
		}
		const params = queryString.split('&');
		const paramsObj = {};
	
		for (let i = 0; i < params.length; i++) {
			const param = params[i].split('=');
			paramsObj[decodeURIComponent(param[0])] = decodeURIComponent(param[1]);
		}
	
		return paramsObj;
	},
	isElementInViewport(element) {
		const rect = element.getBoundingClientRect();
		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	}
}